var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{class:_vm.theme,attrs:{"tft-section-title":""}},[_c('span',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.title))]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }